export enum FileErrorMessages {
  FILE_SIZE_ERROR = 'Invalid file size. Please upload a JPEG or PNG under or exactly 5MB.',
  FILE_TYPE_ERROR = 'Invalid file type. Please upload a JPEG or PNG under or exactly 5MB.',
  IMAGE_SIZE_EXCEEDED = 'Image size exceeds 5MB. Please upload a smaller file.',
  INVALID_FILE_FORMAT = 'Invalid file format. Please upload a PNG, JPG, or JPEG file.'
}
